var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"frame",staticClass:"picture-container",attrs:{"src":'./static/plugin/picture-view/index.html?src=' + _vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }